import { Enums } from '@configur-tech/upit-core-types';

export enum PortalConnections {
  CMS = Enums.ConnectionType.CMS,
  FORM = Enums.ConnectionType.FORM,
  API = Enums.ConnectionType.API,
}
